<template>
  <form id="replacement-card-form" novalidate>
    <replacement-card-sub-form v-for="formDataItem in formData"
                               :ref="`orderReplacementCardSubForm_${formDataItem.cardId}`"
                               :key="formDataItem.cardId"
                               :initial-form-data="formDataItem"
    />

    <button v-if="formData.length > 0"
            type="submit"
            @click.prevent="submitReplacementCardForm"
    >Vraag kaartvervanging aan</button>
  </form>
</template>

<script>
import ReplacementCardSubForm from './ReplacementCardSubForm'
import showAlertErrorHandler from '../../mixins/show-alert-error-handler'
import { mapState } from 'vuex'

export default {
  name: 'ReplacementCardForm',
  components: {
    ReplacementCardSubForm
  },
  mixins: [showAlertErrorHandler],
  computed: {
    ...mapState('orderReplacementCard', [
      'formData'
    ])
  },
  methods: {
    async submitReplacementCardForm () {
      for (const formDataItem of this.formData) {
        let ref = this.$refs['orderReplacementCardSubForm_' + formDataItem.cardId][0]
        ref.touchValidation()
        if (ref.isInvalid()) {
          ref.$el.scrollIntoView()
          return false
        }
      }

      try {
        await this.$store.dispatch('orderReplacementCard/submitOrderReplacementCards')
        this.showAlert(this.$t('orderReplacementCard.orderReplacementCardsSuccess'))
        this.$router.push({name: 'order'})
      } catch (error) {
        if (error.validationErrorResult && error.validationErrorResult.validationErrors) {
          error.validationErrorResult.validationErrors.forEach(propertyError => {
            this.showAlert(this.$te(`orderReplacementCard.validation['${propertyError.code}']`)
              ? this.$t(
                `orderReplacementCard.validation['${propertyError.code}']`,
                { fieldName: this.$t(`orderReplacementCard.fieldName['${propertyError.path}']`) }
              ) : propertyError.message
            )
          })
        } else {
          this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {'name': 'login'}})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/ReplacementCardForm.vue